import React, { forwardRef, LegacyRef } from 'react'
import { classes } from 'src/utils'
import type { OptionalProps } from 'src/utils'

type Props = {
  content: string
  className?: string
} & OptionalProps<{
  editing: boolean
  onChange: (content: string) => void
}>

export const Code = forwardRef(
  (props: Props, ref: LegacyRef<HTMLPreElement> | undefined) => {
    const className = classes(
      'p-4 overflow-x-scroll text-xs rounded bg-slate-100',
      props.className,
    )

    if (props.editing) {
      return (
        <pre
          ref={ref}
          // if we're gonna use dangerouslySetInnerHTML in client components
          // we have to use DOMPurify https://www.npmjs.com/package/dompurify to prevent xss attacks
          dangerouslySetInnerHTML={{ __html: props.content }}
          onInput={(d: React.FormEvent<HTMLPreElement>) => {
            const target = d.target as HTMLPreElement
            props.onChange(target.innerText)
          }}
          contentEditable={props.editing}
          className={className}
        />
      )
    }

    return (
      <pre ref={ref} className={className}>
        {props.content}
      </pre>
    )
  },
)
